import { twMerge } from "tailwind-merge";

interface ColumnTabsProps {
  className?: string;
  options: { icon?: any; label: string; value: string }[];
  value: string;
  onChange: (value: string) => void;
}

export const ColumnTabs = ({ className, options, value, onChange }: ColumnTabsProps) => {
  return (
    <div className={twMerge("p-[4px] rounded bg-white", className)}>
      {options.map((option) => {
        let active = option.value === value;
        return (
          <div
            key={option.value}
            className="h-[40px] flex-row-center gap-[4px] cursor-pointer hover:bg-[#EEF6FD] rounded"
            onClick={() => onChange(option.value)}
          >
            <div className={twMerge("w-[2px] h-[16px]", active ? "bg-primary" : "")}></div>
            {option.icon !== undefined && (
              <option.icon className={twMerge(active ? "stroke-primary" : "stroke-base")}></option.icon>
            )}
            <div className={twMerge(active ? "text-kds-accent font-medium" : "")}>{option.label}</div>
          </div>
        );
      })}
    </div>
  );
};
